module.exports = {"saveBtnLabel":"Zapisz","cancelBtnLabel":"Anuluj","nextWindowBtnLabel":"Dalej","previousBtnLabel":"Wróć"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/translate.json
// module id = 182
// module chunks = 0